import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faStar } from "@fortawesome/free-solid-svg-icons";

const SubscriptionAlert = () => {
  return (
    <div className="flex w-full items-center rounded-lg border border-amber-200 bg-amber-50 p-3 shadow-sm shadow-yellow-100">
      <div className="mr-3 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-yellow-100 to-amber-300">
        <FontAwesomeIcon icon={faStar} className="h-4 w-4 text-amber-600" />
      </div>
      <div>
        <h3 className="text-sm font-semibold text-amber-800">
          Founding 1000 Member Access
        </h3>
        <p className="text-xs leading-snug text-amber-700">
          You&apos;re one of our first 1,000 - Enjoy unlimited seats and early
          feature access at our exclusive pioneer rate.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionAlert;
